import "./scrollToTop.css";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function ScrollToTop() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 600);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      className={`scroll-to-top ${isVisible ? "visible" : ""}`}
      onClick={handleClick}
      aria-label={t("back_to_top")}
      title={t("back_to_top")}
    >
      <span className="material-symbols-outlined">arrow_upward</span>
    </button>
  );
}

export default ScrollToTop;
